import { tokenize } from "components/Input/InputRichCodeEditor/sqlUtils";

function findSafeLineBreakEnd(
  line: string,
  start: number,
  maxLineLength: number,
): number {
  const lineLength = line?.length ?? 0;
  const idealEnd = Math.min(start + maxLineLength, lineLength);
  if (idealEnd >= lineLength) {
    return idealEnd;
  }

  const metaTokens = tokenize(line).filter((token) => token.type === "meta");

  for (const token of metaTokens) {
    if (idealEnd > token.start && idealEnd < token.end) {
      if (token.start > start) {
        return token.start;
      }

      return token.end;
    }
  }

  return idealEnd;
}

function breakLineAtMaxLength(line: string, maxLineLength: number): string {
  if ((line?.length ?? 0) <= maxLineLength) {
    return line ?? "";
  }

  const chunks: string[] = [];
  let start = 0;

  while (start < (line?.length ?? 0)) {
    const end = findSafeLineBreakEnd(line, start, maxLineLength);
    chunks.push(line?.slice(start, end) ?? "");
    start = end;
  }

  return chunks.join("\n");
}

export function applyLineBreaking(
  text: string,
  maxLineLength?: number,
): string {
  if (!maxLineLength || maxLineLength <= 0) return text ?? "";

  const normalizedMaxLineLength = Math.max(1, Math.floor(maxLineLength));

  return (text ?? "")
    .split("\n")
    .map((line) => breakLineAtMaxLength(line, normalizedMaxLineLength))
    .join("\n");
}
